import { Search as SearchIcon } from "@mui/icons-material";
import { Box, TextField, InputAdornment } from "@mui/material";
import React from "react";

import { useCelleraTheme } from "../../../theme/useCelleraTheme";

interface PatientSearchProps {
  value: string;
  onChange: (value: string) => void;
}

const PatientSearch: React.FC<PatientSearchProps> = ({ value, onChange }) => {
  const { colors } = useCelleraTheme();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <Box className="flex-1 max-w-md">
      <TextField
        fullWidth
        placeholder="Search by Email, Name, Phone"
        size="small"
        value={value}
        onChange={handleChange}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon className="text-gray-400" />
              </InputAdornment>
            ),
          },
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            "& fieldset": {
              borderColor: colors.border.light,
            },
            "&:hover fieldset": {
              borderColor: colors.border.main,
            },
            "&.Mui-focused fieldset": {
              borderColor: colors.secondary.main,
            },
          },
        }}
      />
    </Box>
  );
};

export default PatientSearch;
